import { useState, useCallback } from 'react';
import pagosYLiquidacionesService from '../services/pagosYRetencionesService';

const usePagosYRetenciones = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);

  // Obtener datos de pagos y retenciones
  const fetchPagosYRetenciones = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const result = await pagosYLiquidacionesService.getPagosYLiquidaciones(params);
      setData(result.data);
      setTotalItems(result.total);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching pagos y retenciones:', err);
      throw err; // Lanzar el error para que el componente lo pueda capturar
    } finally {
      setLoading(false);
    }
  }, []);

  // Descargar certificado
  const downloadCertificado = useCallback(async (cuit, numeroPago, tipoCertificado) => {
    setLoading(true);
    try {
      const response = await pagosYLiquidacionesService.downloadCertificado(cuit, numeroPago, tipoCertificado);
      const blob = await response.blob();
      const fileName = `${tipoCertificado}_${numeroPago}_Certificado.pdf`;
      
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      
      return { success: true };
    } catch (err) {
      setError(err.message);
      console.error('Error downloading certificado:', err);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  // Exportar a Excel
  const exportToExcel = useCallback(async (params) => {
    setLoading(true);
    try {
      const response = await pagosYLiquidacionesService.exportPagosYLiquidaciones(params);
      const blob = await response.blob();
      
      if (blob) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "PagosYLiquidaciones.xlsx";
        link.click();
      }
      
      return { success: true };
    } catch (err) {
      setError(err.message);
      console.error('Error exporting to Excel:', err);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    data,
    totalItems,
    loading,
    error,
    fetchPagosYRetenciones,
    downloadCertificado,
    exportToExcel
  };
};

export default usePagosYRetenciones;
